

































import Vue from 'vue'
import axios from 'axios'

import peopleInputForm from '@/components/peopleInputForm.vue'
import GalleryUpload from '@/components/galleryUpload.vue'
import Gallery from '@/components/gallery.vue'
import FilesUpload from '@/components/filesUpload.vue'
import Files from '@/components/files.vue'

export default Vue.extend({
  name: 'peopleDetail',
  components: {
    peopleInputForm,
    GalleryUpload,
    Gallery,
    FilesUpload,
    Files
  },
  data: () => ({
    peopleDetail: '',
    defaultTab: 0
  }),
  mounted () {
    axios
      .get(`/api/v1/people/${this.$route.params.id}`)
      .then(response => (this.peopleDetail = response.data))
    this.$nextTick(function () {
      this.defaultTab = parseInt(this.$route.params.tabID)
    })
  },
  methods: {
  }

})
